import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import documentOperations from "../documents/ducks/operations";
import AuditListRow from "./AuditorListRow";
import operations from "./ducks/operations";

const StyledAlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "6em",
    marginBottom: "6em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
});

const AuditListResults = (props) => {
    const { activeTab, auditorList, handleDragEnd, isLoading, role, toggleAuditorListAuditFlag, viewDocument } = props;

    const onDragEnd = (results) => {
        const { destination, source } = results;
        if (!destination) return;
        if (destination.droppableId === source.droppableId && destination.index === source.index) return;
        handleDragEnd(results, auditorList, activeTab);
    };

    let Element = Scroll.Element;

    if (isLoading) {
        return (
            <StyledAlternateContent>
                <CircularProgress color="primary" />
            </StyledAlternateContent>
        );
    }
    if (auditorList === undefined || auditorList.length === 0) {
        return <StyledAlternateContent>Nothing to Show</StyledAlternateContent>;
    }
    return (
        <React.Fragment>
            <div>
                <Element style={{ height: "600px", overflow: "scroll" }}>
                    <React.Fragment>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable" style={{ maxWidth: "100%" }}>
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {auditorList.map((comp, i) => {
                                            return (
                                                <AuditListRow
                                                    role={role}
                                                    i={i}
                                                    comp={comp}
                                                    viewDocument={viewDocument}
                                                    activeTab={activeTab}
                                                    toggleAuditorListAuditFlag={toggleAuditorListAuditFlag}
                                                />
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </React.Fragment>
                </Element>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    activeTab: state.auditReducer.activeTab,
    auditorList: state.auditReducer.auditorList,
    isLoading: state.utilsReducer.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
    handleDragEnd: (results, comps) => {
        dispatch(operations.handleDragEnd(results, comps));
    },
    toggleAuditorListAuditFlag: (dealKey) => {
        dispatch(operations.toggleAuditorListAuditFlag(dealKey));
    },
    viewDocument: (url, document) => {
        dispatch(documentOperations.viewDocument(url, document));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditListResults);
